import React from 'react'
import Tray from '../Video';

import './style.scss'

const BrandTray = (props) => {
  props.layout.settings.displayTags = props.layout.settings.displayTags || false
  props.layout.settings.displayTitle = props.layout.settings.displayTitle || false
  return (
  <div className="netflix-tray brand-tray">
    <Tray {...props} netflix={true} noBadgeImage={true}/>
  </div>
  )
}

export default BrandTray
